import React from 'react';
import { Avatar, Stack, Typography, useTheme } from '@mui/material';
import './styles.css';

type PropTypes = {
  imgPath: string;
  parScore?: number;
  correctAnswer?: boolean;
  roundScore?: number;
};

export const StagedPlayers = ({
  imgPath,
  parScore,
  correctAnswer,
  roundScore,
}: PropTypes) => {
  const theme = useTheme();
  const score =
    parScore !== undefined ? (parScore > 0 ? `+${parScore}` : parScore) : 'N/A';

  const avatarBorderColor = () => {
    if (correctAnswer) return 'success.main';
    return 'error.main';
  };

  return (
    <Stack alignItems="center">
      {/* <div className="profile-pic-cont"> */}
      <Avatar
        src={imgPath}
        variant="square"
        sx={{
          height: { sm: '104px', md: '120px', lg: '128' },
          width: { sm: '104px', md: '120px', lg: '128' },
          border: correctAnswer ? '5px solid' : 'none',
          borderColor: avatarBorderColor(),
          objectFit: 'cover',
          opacity:
            (correctAnswer && roundScore !== undefined) ||
            (!correctAnswer && roundScore)
              ? 0.2
              : 1,
        }}
      ></Avatar>
      {correctAnswer && roundScore !== undefined ? (
        <Typography
          variant="h3"
          color={'success.main'}
          sx={{
            position: 'absolute',
            marginTop: { xs: '8px', sm: '40px' },
            color: '#fff',
            textShadow: `0 0 7px ${theme.palette.success.main}, 0 0 10px ${theme.palette.success.main}, 0 0 21px ${theme.palette.success.dark}, 0 0 42px ${theme.palette.success.dark}, 0 0 82px ${theme.palette.success.dark}, 0 0 92px ${theme.palette.success.dark}, 0 0 102px ${theme.palette.success.dark}, 0 0 151px ${theme.palette.success.dark}`,
          }}
        >
          {roundScore > 0 ? `+${roundScore}` : roundScore}
        </Typography>
      ) : null}
    </Stack>
  );
};
